import { render, staticRenderFns } from "./GridSeleccionDesasociar.vue?vue&type=template&id=02469bc4&"
import script from "./GridSeleccionDesasociar.vue?vue&type=script&lang=ts&"
export * from "./GridSeleccionDesasociar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports